const UNITS = ['B', 'KB', 'MB', 'GB', 'TB'] as const

export function formatBytes(value: number | undefined | null): string {
  if (value == null || !Number.isFinite(value) || value < 0) return ''
  if (value === 0) return '0 B'
  const exponent = Math.min(
    Math.floor(Math.log(value) / Math.log(1024)),
    UNITS.length - 1,
  )
  const scaled = value / 1024 ** exponent
  const decimals = exponent === 0 || scaled >= 100 ? 0 : scaled >= 10 ? 1 : 2
  return `${scaled.toFixed(decimals)} ${UNITS[exponent]}`
}
